import { useState } from 'react';
import {
  Group,
  Header,
  SimpleCell,
  Button,
  Snackbar,
} from '@vkontakte/vkui';
import { apiDownload } from '../../api/client';

export function AdminExport({ role }: { role: string }) {
  const [loading, setLoading] = useState(false);
  const [resultsLoading, setResultsLoading] = useState(false);
  const [hint, setHint] = useState<string | null>(null);
  const handleResultsExport = async () => {
    if (role !== 'admin') return;
    setResultsLoading(true);
    setHint(null);
    try {
      await apiDownload('/api/admin/export/results', `results_${new Date().toISOString().slice(0, 10)}.xlsx`);
      setHint('Результаты скачаны. Сведения об источниках и несопоставленных лицензиях — на втором листе.');
    } catch (e) {
      setHint(e instanceof Error ? e.message : 'Не удалось скачать результаты');
    } finally { setResultsLoading(false); }
  };

  const handleParticipantsExport = async () => {
    setLoading(true);
    setHint(null);
    try {
      const date = new Date().toISOString().slice(0, 10);
      await apiDownload('/api/admin/export/participants', `participants_${date}.xlsx`);
      setHint('Файл с участниками скачан');
    } catch (e) {
      setHint(e instanceof Error ? e.message : 'Не удалось скачать файл');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Group header={<Header size="s">Участники</Header>}>
        <SimpleCell
          multiline
          subtitle="Все данные по каждому участнику: профиль, статус, VK, лицензия (без пароля)."
        >
          <Button
            size="l"
            stretched
            className="pb-gradient-btn"
            loading={loading}
            onClick={() => void handleParticipantsExport()}
          >
            Экспорт участников (XLSX)
          </Button>
        </SimpleCell>
      </Group>

      {role === 'admin' && <Group header={<Header size="s">Результаты</Header>}>
        <SimpleCell multiline subtitle="Рейтинг по сумме времени карт с опубликованными результатами. Карты, которые ещё никто не пролетел, не включаются. Только участники, завершившие хотя бы одну карту. За непройденные карты — контрольное время: 180, 900, 180, 180, 240, 180, 180, 180 с. Загрузка может занять до 40 секунд.">
          <Button size="l" stretched mode="secondary" loading={resultsLoading} disabled={resultsLoading} onClick={() => void handleResultsExport()}>
            Экспорт результатов (XLSX)
          </Button>
        </SimpleCell>
      </Group>}

      {hint && (
        <Snackbar onClose={() => setHint(null)} duration={3000}>
          {hint}
        </Snackbar>
      )}
    </>
  );
}

